/**
 * Estado de la invitación de un Friends & Family en el backoffice.
 *
 * El backend guarda 'pendiente' | 'aceptada' | 'revocada'. 'expirada' se
 * deriva de FechaExpiracion y 'sin_invitacion' de la ausencia de correo.
 */
export const FF_INVITATION_STATUS = {
  NONE: "sin_invitacion",
  PENDING: "pendiente",
  ACCEPTED: "aceptada",
  EXPIRED: "expirada",
  REVOKED: "revocada",
};

export const resolveFFInvitationStatus = (ff) => {
  const invitation = ff?.FFInvitacion;
  const hasEmail = !!String(ff?.Email || "").trim();

  if (!invitation || !invitation.Estado) {
    return hasEmail
      ? FF_INVITATION_STATUS.ACCEPTED
      : FF_INVITATION_STATUS.NONE;
  }

  if (
    invitation.Estado === "pendiente" &&
    invitation.FechaExpiracion &&
    Number(invitation.FechaExpiracion) <= Date.now()
  ) {
    return FF_INVITATION_STATUS.EXPIRED;
  }

  return invitation.Estado;
};

export const ffInvitationLabelKey = (status) => {
  switch (status) {
    case FF_INVITATION_STATUS.PENDING:
      return "friendsFamily__invitationPending";
    case FF_INVITATION_STATUS.ACCEPTED:
      return "friendsFamily__invitationAccepted";
    case FF_INVITATION_STATUS.EXPIRED:
      return "friendsFamily__invitationExpired";
    case FF_INVITATION_STATUS.REVOKED:
      return "friendsFamily__invitationRevoked";
    default:
      return "friendsFamily__invitationNoEmail";
  }
};

export const ffInvitationBadgeType = (status) => {
  switch (status) {
    case FF_INVITATION_STATUS.ACCEPTED:
      return "is-success";
    case FF_INVITATION_STATUS.PENDING:
      return "is-warning";
    case FF_INVITATION_STATUS.EXPIRED:
    case FF_INVITATION_STATUS.REVOKED:
      return "is-danger";
    default:
      return "is-light";
  }
};

export const canResendInvitation = (ff) => {
  const status = resolveFFInvitationStatus(ff);
  return !!String(ff?.Email || "").trim() && status !== FF_INVITATION_STATUS.ACCEPTED;
};

export const canRevokeInvitation = (ff) => {
  const status = resolveFFInvitationStatus(ff);
  return [
    FF_INVITATION_STATUS.PENDING,
    FF_INVITATION_STATUS.EXPIRED,
    FF_INVITATION_STATUS.REVOKED,
  ].includes(status);
};
